import { DynamicStringSchema, ActionSchema } from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { NoteComposer } from './NoteComposer';

interface ResolvedProps {
  readonly referenceId?: string;
  readonly title?: string;
  readonly noteTypes?: string;
  readonly body?: string;
  readonly onCancel?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  referenceId: DynamicStringSchema,
  title: DynamicStringSchema,
  noteTypes: DynamicStringSchema,
  body: DynamicStringSchema,
  onCancel: ActionSchema,
}) as any;

export const NoteComposerImpl = createComponentImplementation(
  { name: 'NoteComposer', schema },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ props }: { props: ResolvedProps; buildChild: any; context: any }) => (
    <NoteComposer
      referenceId={props.referenceId}
      title={props.title}
      noteTypes={props.noteTypes}
      body={props.body}
      onCancel={props.onCancel}
    />
  )
);
